var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyPosts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-My_Posts"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My_Posts",
    clipPath: "url(#clip-My_Posts)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1940",
    "data-name": "Group 1940",
    transform: "translate(-37 3.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M70.18,80H45.617A1.619,1.619,0,0,0,44,81.617v32.642a1.619,1.619,0,0,0,1.617,1.617H70.18a1.619,1.619,0,0,0,1.616-1.617V81.617A1.619,1.619,0,0,0,70.18,80ZM64.7,102.768H51.589a1.38,1.38,0,1,1,0-2.76H64.7a1.38,1.38,0,1,1,0,2.76Zm0-5.519H51.589a1.38,1.38,0,1,1,0-2.76H64.7a1.38,1.38,0,1,1,0,2.76Zm0-5.519H51.589a1.38,1.38,0,1,1,0-2.76H64.7a1.38,1.38,0,1,1,0,2.76Z",
    transform: "translate(0 -73.101)",
    fill: "#2591ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M128.246,4.14V34.5a4.287,4.287,0,0,1-4.63,4.14V8.516A4.381,4.381,0,0,0,119.24,4.14H97.69A4.272,4.272,0,0,1,102.074,0h21.787A4.272,4.272,0,0,1,128.246,4.14Z",
    transform: "translate(-49.06 0)",
    fill: "#2591ce"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPosts);
export default __webpack_public_path__ + "static/media/My_Posts.21502c68.svg";
export { ForwardRef as ReactComponent };